import React, { useEffect, useState } from "react";
import NavbarHeader from "../../../Navbarheader/NavbarHeader";
import Footer from "../../../Footer/Footer";
import HeroSection from "./components/Herosection";






import NextProjectButton from "../components/NextProjectButton";

import { useNavigate } from 'react-router-dom';
import Brief from "./components/brief";
import ColorGuide from "./components/colorguide";
import Banner from "./components/banner";
import Brandcar from "./components/brandcar";
import Cargo from "./components/cargo";
import Bento from "./components/bento";
import Briefintro from "./components/briefintro";




function Lodabranding() {
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 768);
 const navigate = useNavigate()

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);


  const handleNextProjectClick = () => {
    navigate('/project/notarymeet');
  };

  

  return (
    <div fluid className="scroll-container">
      <NavbarHeader />
      <div
        style={{
          backgroundColor: "#181818",
          paddingTop: isSmallScreen ? "6rem" : "0px",
        }}
      >
        <HeroSection />
        <Briefintro />
        <Brief />
        <ColorGuide />
        <Banner />
        <Brandcar />
        <Cargo />
       
    
       
        <div id="showNextButton">
           <Bento />
        </div>
      </div>
      <Footer />

      <NextProjectButton 
        sectionId="showNextButton" 
        onClick={handleNextProjectClick} 
      />

     
    </div>
  );
}

export default Lodabranding;
